import { render, staticRenderFns } from "./stores-view-toolbar.vue?vue&type=template&id=24c66701&scoped=true&"
import script from "./stores-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./stores-view-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./stores-view-toolbar.vue?vue&type=style&index=0&id=24c66701&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c66701",
  null
  
)

export default component.exports
import {QBtn,QSpinnerIos} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QSpinnerIos})
